"use strict";
// Refactoring the code
let secretNumber = Math.trunc(Math.random() * 20) + 1;
let score = 20;
let hignScore = 0;
document.querySelector(".check").addEventListener("click", function() {
    const guess = Number(document.querySelector(".guess").value);
    console.log(guess, typeof guess);
    // when thers is no input
    if (!guess) document.querySelector(".message").textContent = "\u26D4 No Number!";
    else if (guess === secretNumber) {
        document.querySelector(".message").textContent = "\uD83C\uDF89 Correct Number";
        document.querySelector(".number").textContent = secretNumber;
        document.querySelector("body").style.backgroundColor = "#60b347";
        document.querySelector(".number").style.width = "30rem";
        if (score > hignScore) {
            hignScore = score;
            document.querySelector(".highscore").textContent = hignScore;
        }
    } else if (guess !== secretNumber) {
        if (score > 1) {
            document.querySelector(".message").textContent = guess > secretNumber ? "\uD83D\uDCC8 Too High!" : "\uD83D\uDCC9Too low!";
            score--;
            document.querySelector(".score").textContent = score;
        } else {
            document.querySelector(".message").textContent = "\uD83D\uDE12 You lost the Game!";
            document.querySelector(".score").textContent = 0;
        }
    }
});
document.querySelector(".again").addEventListener("click", function() {
    score = 20;
    secretNumber = Math.trunc(Math.random() * 20) + 1;
    document.querySelector(".message").textContent = "Start guessing...";
    document.querySelector(".score").textContent = score;
    document.querySelector(".number").textContent = "?";
    document.querySelector(".guess").value = "";
    document.querySelector("body").style.backgroundColor = "#222";
    document.querySelector(".number").style.width = "15rem";
});

//# sourceMappingURL=index.89191e21.js.map
